<template>
  <div class="health">
    <div class="healthy">
      <van-image class="img" :src="require('@/assets/m-img-1.png')" height=410 width="100%" fit="contain" />
      <!-- <div class="healthy-info">
        <h2>共同守护青少年身心健康</h2>
        <p>依蛋守护是一款家长守护孩子的应用，</p>
        <p>帮助家长正确引导孩子的手机使用习惯，</p>
        <p>科学智能地防止孩子沉迷手机，守护孩子健康、有度地上网！</p>
      </div> -->
    </div>
    <div class="healthy_download">
      <a :href="url"></a>
    </div>
  </div>
</template>

<script>
import { url } from '@/data/index'
export default {
  data() {
    return {
      url: url
    }
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.healthy {
  position: relative;
  width: 100%;
  height: 410px;
  /* background-color: #fff;
  background: url('@/assets/m-box-1-bg.png') no-repeat;
  background-size: cover; */
}

.img {
  padding: 8px 0 10px;
}

.healthy-info {
  text-align: center;
}

.healthy-info h2 {
  font-size: 24px;
  color: #fff;
  margin-bottom: 15px;
}

.healthy-info p {
  font-size: 12px;
  line-height: 15px;
  color: #BCF1F3;
}

.healthy_download {
  position: absolute;
  left: 50%;
  /* right: -50%; */
  transform: translate(-50%, -107%);
  width: 165px;
  height: 50px;
  /* background-color: pink; */
  /* background-image: url('@/assets/m-box-1-download.png');
  background-size: cover; */
}

.healthy_download a {
  display: block;
  width: 165px;
  height: 50px;
}
</style>
